import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "",
  alt: ""
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_home = _resolveComponent("home");
  const _component_exp = _resolveComponent("exp");
  const _component_falv = _resolveComponent("falv");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_home), _createVNode(_component_exp), _createVNode(_component_falv), _hoisted_1], 64);
}